import React, { useState } from "react";
import SimpleParagraph from "../../Atoms/SimpleParagraph";
import Image from "../../Atoms/Image";
import Button from "../../Atoms/Button";
import CustomDiv from "../../Molecules/CustomDiv";
import IAAvatarBlock from "../../Molecules/IAAvatarBlock";
import CodeDiffModal from "../../Parts/DiffModal/CodeDiffModal";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import AiraFlag from "../../../assets/img/logo-mjv-aira-star.svg"

import {
  faCopy,
  faThumbsUp,
  faThumbsDown,
  faDownload,
  faAngleDown,
  faAngleUp,
} from "@fortawesome/free-solid-svg-icons";

const Message = ({
  msg,
  codePair,
  diff,
  handleDownloadDocx,
  OnLikeButtonPress,
}) => {
  const [isStatusOpen, setIsStatusOpen] = useState(false);

  const isSystemMessage = (message) =>
    message.startsWith("<system-context>") &&
    message.endsWith("</system-context>");

  // Verifica se há status para exibir:
  const hasStatus = msg.statusUpdates && msg.statusUpdates.length > 0;
  const lastStatus = hasStatus
    ? msg.statusUpdates[msg.statusUpdates.length - 1]
    : null;

  return (
    !isSystemMessage(msg.content) && (
      <CustomDiv className={"mb-3"} key={msg.id}>
        <CustomDiv
          className={`d-flex flex-row ${
            msg.role === "user"
              ? "justify-content-end"
              : "justify-content-start"
          }`}
        >
          {msg.role === "assistant" && (
            <IAAvatarBlock className="d-flex justify-content-center align-items-center">
              <Image src={AiraFlag} style={{color: "#A684FF", backgroundColor: "#A684FF"}} alt="Iron Flag" width="20" height="20" />
            </IAAvatarBlock>
          )}
          <CustomDiv
            className={`p-0 px-2 ${
              msg.role === "user" ? "px-4 py-2 m-block" : "ms-2 m-block-iron"
            }`}
          >
            {/* Painel de Status (se existir statusUpdates) */}
            
            <SimpleParagraph className="mb-0" msg={msg} />
            {hasStatus && (
              <CustomDiv className="mt-1" style={{ fontSize: "0.9rem" }}>
                <Button
                  onClick={() => setIsStatusOpen(!isStatusOpen)}
                  style={{ backgroundColor: "transparent", color: "#666" }}
                >
                  {isStatusOpen ? (
                    <>
                      <FontAwesomeIcon icon={faAngleUp} /> Esconder status
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faAngleDown} /> Mostrar status
                    </>
                  )}
                </Button>

                {/* Se estiver aberto, mostra todos os status. Caso contrário, só o último. */}
                {isStatusOpen ? (
                  <ul style={{ listStyle: "inside", paddingLeft: "0" }}>
                    {msg.statusUpdates.map((st, idx) => (
                      <li key={idx} style={{ marginBottom: "4px" }}>
                        {st}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <CustomDiv style={{ color: "#999" }}>
                    Último status: {lastStatus}
                  </CustomDiv>
                )}
              </CustomDiv>
            )}
            {codePair && (
              <CustomDiv
                className="btn mt-auto p-1 align-self-start"
                style={{ width: "auto" }}
              >
                {diff && (
                  <CodeDiffModal
                    code1={codePair.userCode}
                    code2={codePair.assistantCode}
                  />
                )}
              </CustomDiv>
            )}
          </CustomDiv>
        </CustomDiv>
        

        {/* Botões do Assistant (copy/like/dislike/download) */}
        {msg.role === "assistant" && (
          <CustomDiv className="msg-actions-row">
            <button
              className="msg-action-btn"
              onClick={() => navigator.clipboard.writeText(msg.content)}
              title="Copiar"
            >
              <FontAwesomeIcon icon={faCopy} />
            </button>

            <button
              className="msg-action-btn"
              onClick={() => OnLikeButtonPress(true, msg.id)}
              title="Like"
            >
              <FontAwesomeIcon
                icon={faThumbsUp}
                className={msg.like_option === "like" ? "like-active" : ""}
              />
            </button>

            <button
              className="msg-action-btn"
              onClick={() => OnLikeButtonPress(false, msg.id)}
              title="Dislike"
            >
              <FontAwesomeIcon
                icon={faThumbsDown}
                className={msg.like_option === "dislike" ? "dislike-active" : ""}
              />
            </button>

            <button
              className="msg-action-btn"
              onClick={() => handleDownloadDocx(msg.content)}
              title="Download"
            >
              <FontAwesomeIcon icon={faDownload} />
            </button>
          </CustomDiv>
        )}
      </CustomDiv>
    )
  );
};

export default Message;
